module.exports = __webpack_public_path__ + "media/landing/middle-page-wave-5f554cba.png";